import * as types from './mutation-types'
import { storeClient } from '@/service/apiClients'

export default {
  async syncStationList ({ rootGetters, commit }) {
    try {
      const { data: workStationList } = await storeClient.get(`stores/${rootGetters.storeId}/kitchenStations`)
      commit(types.SET_WORKSTATION_LIST, workStationList)
    } catch (e) {
      console.error(e)
    }
  },
  async setCurrentWorkStation ({ rootGetters, commit, state }, stationId) {
    try {
      commit(types.TOGGLE_WORKSTATION, stationId)
      commit(types.TOGGLE_IS_MAIN_CHANNEL)
    } catch (e) {
      console.log(e)
    }
  },
  toggleMainChannel ({ rootGetters, commit, state }) {
    commit(types.TOGGLE_IS_MAIN_CHANNEL)
  }
}
